export default "__VITE_ASSET__DKotNh_4__"